
import { useEffect, useState } from "react"

export default function useWindowSize() {
  const [screenSize, setScreenSize] = useState(0)

  const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1440,
  }

  useEffect(() => {
    setScreenSize(window.innerWidth)
    window.addEventListener("resize", () => {
      setScreenSize(window.innerWidth)
    })
    return () => {
      window.removeEventListener("resize", () => {
        setScreenSize(window.innerWidth)
      })
    }
  }, [])

  return {
    isSm: screenSize > breakpoints.sm,
    isMd: screenSize > breakpoints.md,
    isLg: screenSize > breakpoints.lg,
    isXl: screenSize > breakpoints.xl,
  }
}
